import { API, getRequest } from '@/api/api';

import type { BetaFeatureGroup } from './beta-features.dto';

/** The caller's own audience; the backend never answers for anyone else's. */
export const getMyBetaFeatureGroup = async (): Promise<BetaFeatureGroup> => {
  const res = await getRequest<BetaFeatureGroup>(API.PEOPLE, '/beta-features/groups/me');
  return res.data;
};
